import { MenuMode, MenuConfig } from '@rappider/rappider-components/utils';

export const COMPONENT_DEFINITIONS_GROUP_MENU: MenuConfig = {
  items: [
  ],
  mode: MenuMode.Inline
};
